import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '@/components/container';
import { Experience } from './type';
import Icon from '@icon-park/react/es/all';
import './experience.style.scss';
import { ClassNames } from '@/modules/classNames';


function ExperienceSection() {
	const CN = new ClassNames('experience');
	const { t} = useTranslation(['experience']);
	const objective1: Array<string> = new Array(9).fill(0).map((item, index) => t(`1.${index}`));
	const objective2: Array<string> = new Array(7).fill(0).map((item, index) => t(`2.${index}`));
	const objective3: Array<string> = new Array(5).fill(0).map((item, index) => t(`3.${index}`));

	const experiencesList: Array<Experience> = [
		{
			title: 'Pearson',
			type: 'Remote',
			position: 'Sr. Software Engineer',
			location: 'New York, NY, 10019',
			date: '05/2025 - Present',
			translation_key: 'objective1',
			objectives: objective1,
		},
		{
			title: 'Nike',
			type: 'Remote',
			position: 'Sr. Software Engineer',
			location: 'Beaverton, OR, 97005',
			date: '08/2021 - 05/2025',
			translation_key: 'objective2',
			objectives: objective2,
		},
		{
			title: 'Epic Games',
			type: 'Remote',
			position: 'Fullstack Developer',
			location: 'Cary, NC, 27518',
			date: '01/2016 - 08/2021',
			translation_key: 'objective3',
			objectives: objective3,
		},
	];

	return (
		<section className={CN.generate()}>
			<span className={CN.generate('circle', ['one'])} />
			<span className={CN.generate('circle', ['two'])} />
			<span className={CN.generate('circle', ['three'])} />
			<span className={CN.generate('circle', ['four'])} />
			<Container>
				{experiencesList.map((item: Experience) => (
					<div className={CN.generate('item')}>
						<span className={CN.generate('bullet')}></span>
						<span>{item.title} <em>({item.type})</em></span>
						<h2>{ item.position }</h2>
						<div className={CN.generate('details')}>
							<span>{ item.location }</span>
							<p>{ item.date }</p>
						</div>
						<ul>
							{item.objectives.map((objective: string, index: number) => (
								<li className={CN.generate('objective')} key={`${item.translation_key}_${index}`}>
									<Icon type={'Dot'} theme={'outline'} size={24} />
									<p>{objective}</p>
								</li>
							))}
						</ul>
					</div>
				))}
			</Container>
		</section>
	);
}

export default ExperienceSection;
